import { lazy } from 'react'

export const MotivationPreview = lazy(() => import('./MotivationPreview'))
